import React, { useEffect, useState } from "react";
import TextInput from "../../../components/TextInput";
import SearchButton from "../../../components/SearchButton";
import RefreshButton from "../../../components/RefreshButton";
import { useLocation } from "react-router";

const TableFilters = ({
  setFilterText,
  disabledButton,
  placeholder,
  setLOBTypeFilteredData,
  setProdCodeTypeFilteredData,
  setCProgramFilteredData,
  setMgaFilteredData,
  setDisChannelFilteredData,
  setCodeLevelFilteredData,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [filteredData, setFilteredData] = useState(undefined);

  let location = useLocation();
  let recordIdFromRecent;

  if (location.state == null) {
    //Do nothing
  } else {
    recordIdFromRecent = location.state;
  }

  useEffect(() => {
    if (recordIdFromRecent !== undefined) {
      setFilteredData(recordIdFromRecent);
    }
  }, []);
  return (
    <div>
      <div className="grid grid-cols-4 items-center gap-2">
        <div className="col-span-2">
          <TextInput
            value={inputValue}
            placeholder={placeholder}
            className="mr-18 outline-none focus:ring-septenary focus:border-septenary"
            disabled={disabledButton}
            onChange={(e) => {
              setInputValue(e.target.value);
            }}
          />
        </div>
        {/* <div className="flex justify-center items-end gap-x-2 mb-12  lg:ml-4 md:ml-1 rounded-md mt-5"> */}
        <SearchButton
          buttonValue="Search"
          className={
            inputValue === "" || disabledButton ? "opacity-50" : "opacity-100"
          }
          disabled={inputValue === "" || disabledButton ? true : false}
          onClick={() => {
            setFilterText(inputValue);
          }}
        />
        <div className="flex flex-row col-span-1">
          <RefreshButton
            className={
              (filteredData === undefined && inputValue === "") ||
              disabledButton
                ? "opacity-50"
                : "opacity-100"
            }
            disabled={
              (filteredData === undefined && inputValue === "") ||
              disabledButton
                ? true
                : false
            }
            onClick={() => {
              if (!disabledButton) {
                setLOBTypeFilteredData([]);
                setCProgramFilteredData([]);
                setProdCodeTypeFilteredData([]);
                setMgaFilteredData([]);
                setDisChannelFilteredData([]);
                setCodeLevelFilteredData([]);
                setFilterText("");
                setInputValue("");
                setFilteredData(undefined);
              }
            }}
          />
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default TableFilters;
